<template>
	<div class="flex flex_column" style="overflow: hidden">
		<h5 class="font_bold" style="margin-bottom: 2rem">
			{{ title }}
		</h5>
		<div class="flex" style="overflow: hidden">
			<div class="flex_1 flex flex_column">
				<h4 class="list-group-title">
					{{ $t("common.draggableFieldSelector.allFields") }}
				</h4>
				<div class="flex_1 list-group">
					<div class="list-group-item"
						 v-for="(element, index) in options"
						 :key="element[optionsKeyField]"
					>
						<md-checkbox v-model="element[optionsSelectedField]"
									 :id="index"
									 @change="onSelectedChanged(index)"
						>
							{{ element[optionsDisplayField] }}
						</md-checkbox>
					</div>
				</div>
			</div>
			<div class="margin_horizontal"></div>
			<div class="flex_1 flex flex_column">
				<h4 class="list-group-title">
					{{ $t("common.draggableFieldSelector.selectedFields") }}
				</h4>
				<draggable class="flex_1 list-group"
						   :list="selectedOptions"
				>
					<div class="list-group-item flex flex_between"
						 style="box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.2); background-color: #f9f9f9"
						 v-for="(element, index) in selectedOptions"
						 :key="element[optionsDisplayField]"
					>
						<div>
							<i class="fa fa-bars" style="margin: 5px;" aria-hidden="true"/>
							{{ element[optionsDisplayField] }}
						</div>
						<i class="fa fa-times close" style="margin: 3px;" aria-hidden="true"
						   @click="onSelectedRemoved(index)"
						/>
					</div>
				</draggable>
			</div>

		</div>
	</div>
</template>

<script>
import draggable from "vuedraggable";

export default {
	props: {
		title: String,
		options: { type: Array, default: [] },
		selectedOptions: { type: Array, default: [] },
		optionsKeyField: { type: String, default: "" },
		optionsDisplayField: { type: String, default: "" },
		optionsSelectedField: { type: String, default: "" },
	},
	components: {
		draggable
	},
	data() {
		return {

		};
	},

	methods: {
		onSelectedRemoved(idx) {
			for (let i = 0; i < this.options.length; i++) {
				if (this.options[i][this.optionsKeyField] === this.selectedOptions[idx][this.optionsKeyField]) {
					this.options[i][this.optionsSelectedField] = false;
          this.selectedOptions.splice(idx, 1);
					break;
				}
			}
		},
		onSelectedChanged: function(id) {
      for (let i = 0; i < this.selectedOptions.length; i++) {
        if (this.selectedOptions[i][this.optionsKeyField] === this.options[id][this.optionsKeyField]) {
          this.selectedOptions.splice(i, 1);
          return;
        }
      }
      this.selectedOptions.push(this.options[id]);
		},

	}

};
</script>

<style lang="scss">
@import "@/assets/scss/base_variables.scss";

.list-group-title {
	text-align: left;
	margin-left: 5px;
}

.list-group {
	box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.2);
	padding: 5px 10px;
	overflow-y: auto;
	margin: 10px 5px 5px;
	border-radius: 6px;
	text-align: left;
  max-height: 800px;
}

.list-group-item {
	box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
	margin-top: 5px;
	margin-bottom: 5px;
	height: 25px;
	cursor: pointer;

	.md-checkbox {
		margin: 0;
	}

	i {
		color: $gray-light;
	}
}
</style>